import {
  EmbededSigmaLinkResponseDto,
  EmbedRequestBodyDto,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpoint-definition';

export const sigmaEmbedRequests = {
  getEmbededSigmaRequest: EndpointDefinition.post<
    EmbededSigmaLinkResponseDto,
    EmbedRequestBodyDto,
    null
  >({
    name: 'getEmbededSigmaRequest',
    route: '/users/sigma-embed',
  }),
};
